module.exports = __webpack_public_path__ + "static/media/anatomia.c06bf342.png";